import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Loading from './Loading';
import { AppRoutesProps } from 'types';

// Lazy load de los componentes de las páginas
const Home = lazy(() => import('pages/home'));
const About = lazy(() => import('pages/about'));
const Contact = lazy(() => import('pages/contact'));
const Portfolio = lazy(() => import('pages/portfolio'));
const Resume = lazy(() => import('pages/resume'));
const Certificates = lazy(() => import('pages/certificates'));
const PrintCv = lazy(() => import('pages/cv'));
const Err404 = lazy(() => import('pages/error'));

export default function AppRoutes({ setNavbarVisible, setSidebarVisible, isSidebarExpanded, setPageTitle }: AppRoutesProps) {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Rutas válidas donde el Navbar está visible */}
        <Route path="/" element={
          <Home
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
            isSidebarExpanded={isSidebarExpanded}
          />
        } />
        <Route path="/about" element={
          <About
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
            isSidebarExpanded={isSidebarExpanded}
          />
        } />
        <Route path="/resume" element={
          <Resume
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
            isSidebarExpanded={isSidebarExpanded}
          />
        } />
        <Route path="/certificates" element={
          <Certificates
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
            isSidebarExpanded={isSidebarExpanded}
          />
        } />
        <Route path="/portfolio" element={
          <Portfolio
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
            isSidebarExpanded={isSidebarExpanded}
          />
        } />
        <Route path="/cv" element={
          <PrintCv
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
          />
        } />
        <Route path="/contact" element={
          <Contact
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
          />
        } />
        {/* Ruta de error 404 sin mostrar el Navbar */}
        <Route path="*" element={
          <Err404
            setPageTitle={setPageTitle}
            setNavbarVisible={setNavbarVisible}
            setSidebarVisible={setSidebarVisible}
          />
        } />
      </Routes>
    </Suspense>
  );
}
